<template>
  <div class="feat-card">
    <div class="feat-icon feat-icon--auto">
      <v-icon dark>loop</v-icon>
    </div>

    <div class="feat-body">
      <div class="feat-title">Antecipação Automática</div>
      <div class="feat-desc">
        Antecipe todo seu crédito disponível e receba suas vendas de crédito
        <b>à vista</b>.
      </div>
      <div class="feat-chips">
        <span class="feat-chip">
          <v-icon small class="feat-chip__icon">account_balance_wallet</v-icon>
          Disponível: {{ $n(balance, "currency") }}
        </span>
        <span class="feat-chip">
          <v-icon small class="feat-chip__icon">percent</v-icon>
          Taxa: {{ tax && tax.automatic_tax ? tax.automatic_tax : "N/A" }}% a.m
        </span>
      </div>
    </div>

    <div class="feat-action">
      <v-switch v-model="activated" :disabled="pending" color="primary"></v-switch>
      <div v-if="pending" class="feat-pending">Em análise</div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions } from "vuex";
import { EventBus } from "@/services/event-bus";

export default {
  name: "AutomaticAntecipation",
  computed: {
    ...mapGetters({
      balance: "user/balance",
      tax: "user/anticipationTax",
      color: "account/color",
      rule: "user/automaticAnticipationEnabled",
      pending: "user/anticipationRequestPending",
    }),
    activated: {
      get() {
        return this.rule;
      },
      set(newRule) {
        if (this.pending) return;
        if (newRule === false) {
          // Turning off drops an automatic_off request in the backoffice queue.
          this.requestAnticipation("automatic_off");
        } else {
          // Turning on requires accepting the terms; the modal creates the
          // automatic_on request.
          EventBus.$emit("anticipation.terms.modal.show");
        }
      },
    },
  },
  methods: {
    ...mapActions({
      requestAnticipation: "user/requestAnticipation",
      loadAnticipationRequestStatus: "user/loadAnticipationRequestStatus",
    }),
  },

  created() {
    this.loadAnticipationRequestStatus();
  },
};
</script>

<style scoped>
.feat-card {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  background: #fafbfc;
  border: 1px solid #eef1f5;
  border-radius: 18px;
  padding: 18px 20px;
  transition: box-shadow 0.18s ease, transform 0.18s ease;
}
.feat-card:hover {
  box-shadow: 0 8px 22px rgba(17, 24, 39, 0.07);
}

.feat-icon {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.feat-icon--auto {
  background: linear-gradient(135deg, #5b8def, #2f6fe0);
  box-shadow: 0 6px 14px rgba(47, 111, 224, 0.32);
}

.feat-body {
  flex: 1;
  min-width: 0;
}

.feat-title {
  font-size: 16px;
  font-weight: 700;
  color: #1f2933;
}

.feat-desc {
  font-size: 13.5px;
  color: #4b5563;
  margin: 4px 0 10px;
  line-height: 1.45;
}

.feat-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.feat-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: #eef2f7;
  color: #37475a;
  font-size: 12.5px;
  font-weight: 600;
  border-radius: 999px;
  padding: 4px 12px;
}
.feat-chip__icon {
  font-size: 15px !important;
  color: #7a8699 !important;
}

.feat-action {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.feat-pending {
  font-size: 11px;
  font-weight: 700;
  color: #e0791a;
  background: #fff3e0;
  border-radius: 999px;
  padding: 2px 10px;
  margin-top: -4px;
}

@media screen and (max-width: 600px) {
  .feat-card {
    flex-wrap: wrap;
  }
  .feat-action {
    flex-direction: row;
    gap: 8px;
    align-items: center;
    width: 100%;
    justify-content: flex-end;
  }
}
</style>
